<div>
  <tyt-full-layout>
    <tyt-sub-nav [show]="show" [activeLiveStream]="activeLiveStream" [section]="mode"></tyt-sub-nav>
    <div class="player-box" [class.has-paywall]="paywallVisible" [class.hidden]="!paywallVisible && mode == 'podcasts'">
      <media-player #player 
        [inline]="true"
        [autoplay]="false"
        (paywallVisible)="paywallVisible = $event"
        (currentItemChanged)="currentItem = $event"></media-player>
    </div>
    <div *ngIf="mode == 'podcasts' && !paywallVisible && currentItem" class="podcast-player">
      <div class="current-item" *ngIf="currentItem">
        <div class="production-date">{{production.date_simple | date : 'mediumDate'}}</div>
        <h1>
          {{title}}
        </h1>
  
        <div>
          <ng-container *ngIf="currentItem.is_premium && !currentItem.unlock_premium">
            <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
            <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
          </ng-container>
          <tyt-plus-unlocked *ngIf="currentItem.unlock_premium"></tyt-plus-unlocked>
        </div>
  
        <ul class="stats">
          <li>{{currentItem.duration | duration}}</li>
          <li><tyt-comments-count [identifier]="topicIdentifier"></tyt-comments-count></li>
        </ul>
  
      </div>
      <tyt-remote-audio-player></tyt-remote-audio-player>
    </div>

    <div class="current-item" *ngIf="mode != 'podcasts' && currentItem">

      <div id="play-options" *ngIf="currentItem && currentlyPlayingVOD.asset" [class.open]="showPlaybackOptions">
        <a class="opener" href="javascript:;" (click)="showPlaybackOptions = !showPlaybackOptions" aria-label="Playback Options">
          <i class="fas fa-cog"></i> 
          <span class="options-label" *ngIf="showPlaybackOptions">Playback Options</span>
          <div class="spacer">
          </div>
          <i *ngIf="showPlaybackOptions" class="fas fa-angle-up"></i>
          <i *ngIf="!showPlaybackOptions" class="fas fa-angle-down"></i>
        </a>
        <div class="option-list">
            <hr/>
            <ng-container *ngIf="!entitled">
                <a routerLink="{{loginOrJoinUrl}}">
                  <i class="far fa-arrow-alt-circle-down"></i> 
                  Download HD [members only]
                </a>
                <a routerLink="{{loginOrJoinUrl}}">
                      <i class="far fa-arrow-alt-circle-down"></i> 
                      Download SD [members only]
                </a>
                <a routerLink="{{loginOrJoinUrl}}">
                      <i class="far fa-arrow-alt-circle-down"></i> 
                      Download Audio [members only]
                </a>
            </ng-container>
            <ng-container *ngIf="entitled">
              <a [class.unavailable]="!currentlyPlayingVOD.asset.hd_video_download_url" 
                  href="{{currentlyPlayingVOD.asset.hd_video_download_url}}" 
                  title="Right click or long tap to download"
                  target="_blank">
                    <i class="far fa-arrow-alt-circle-down"></i> 
                    Download HD
                    <span class="not-available-text" *ngIf="!currentlyPlayingVOD.asset.hd_video_download_url">[not available]</span>
              </a>
              <a [class.unavailable]="!currentlyPlayingVOD.asset.sd_video_download_url" 
                  href="{{currentlyPlayingVOD.asset.sd_video_download_url}}" 
                  title="Right click or long tap to download"
                  target="_blank">
                    <i class="far fa-arrow-alt-circle-down"></i> 
                    Download SD
                    <span class="not-available-text" *ngIf="!currentlyPlayingVOD.asset.sd_video_download_url">[not available]</span>
              </a>
              <a [class.unavailable]="!currentlyPlayingVOD.asset.audio_download_url"
                  href="{{currentlyPlayingVOD.asset.audio_download_url}}"
                  title="Right click or long tap to download"
                  target="_blank">
                    <i class="far fa-arrow-alt-circle-down"></i> 
                    Download Audio
                    <span class="not-available-text" *ngIf="!currentlyPlayingVOD.asset.audio_download_url">[not available]</span>
              </a>
              <!--
                TODO: stream audio for VOD
              <a *ngIf="!audioMode" [class.unavailable]="currentlyPlayingVOD.asset.audio_download_url" href="javascript:;" (click)="playAudio()"><i class="fas fa-podcast"></i> Stream Audio Only</a>
              -->
            </ng-container>

            <hr/>
  
            <em class="explanation">Note: You may need to right click or long tap on the link and select 'Save File'</em>
        </div>
      </div>

      <div class="production-date">{{production.date_simple | date : 'mediumDate'}}</div>
      <h1>
        {{title}}
      </h1>

      <div class="description" [innerHTML]="currentItem.description | newlinesToHtml | linksToHtml | trustHtml"></div>

      <div>
        <ng-container *ngIf="currentItem.is_premium && !currentItem.unlock_premium">
          <tyt-plus-tag *ngIf="audienceType === 'member'"></tyt-plus-tag>
          <tyt-plus-locked *ngIf="audienceType !== 'member'"></tyt-plus-locked>
        </ng-container>
        <tyt-plus-unlocked *ngIf="currentItem.unlock_premium"></tyt-plus-unlocked>
      </div>

      <ul class="stats">
        <li>{{currentItem.duration | duration}}</li>
        <li><tyt-comments-count [identifier]="topicIdentifier"></tyt-comments-count></li>
      </ul>

    </div>

    <div class="row" id="feed">
      <div class="col-lg-8 col-md-8 col-sm-12 col-xs-12">
        <div *ngIf="show && mode == 'podcasts'">
          <div class="options-and-social">
            <tyt-social-buttons></tyt-social-buttons>
            <div class="spacer"></div>
            <div class="feed-options" *ngIf="show">
              <span class="available">Available </span>
              <a *ngFor="let provider of getPodcastProviders(show)" 
                [responsiveBackgroundImage]="provider.logo_square || provider.logo" 
                [attr.aria-label]="provider.name"
                title="{{provider.name}}"
                target="_blank" 
                href="{{provider.url}}">
              </a>
              <a routerLink="/podcasts/{{show.id}}" aria-label="Get the members-only podcast on your favorite app" title="Members-only Podcast">
                <i class="fas fa-rss"></i>
              </a>
            </div>
          </div>
        </div>
        <ng-container *ngIf="topicIdentifier">
          <tyt-social-buttons *ngIf="mode != 'podcasts'"></tyt-social-buttons>
          <tyt-comments [identifier]="topicIdentifier" [title]="topicTitle"></tyt-comments>
        </ng-container>
      </div>
      <div id="sidebar" class="col-lg-4 col-md-4 col-sm-12 col-xs-12">

          <tyt-production-view 
            class="mini"
            [production]="production" 
            [mode]="mode" 
            [playInline]="true" 
            [playRemote]="true" 
            [showImage]="false" 
            [showFeedTag]="true" 
            [currentlyPlayingItem]="currentItem"
            (playClicked)="playItem($event, playlist)"></tyt-production-view>

          <ng-container *ngFor="let recentEpisode of recentEpisodes">
            <tyt-production-view 
              *ngIf="recentEpisodes" 
              class="mini" 
              [production]="recentEpisode" 
              [showImage]="mode !== 'podcasts'"
              [mode]="mode" 
              limit="2">
            </tyt-production-view>
          </ng-container>
      </div>

    </div>
  </tyt-full-layout>
</div>